module.exports = __webpack_public_path__ + "static/media/three-dots.d087e753.svg";